import { DEFAULT_VALUE } from "@/utils/config";
import { isNil, isUndefined, get } from "lodash-es";

/**
 * 将对象转化为formData
 * @param obj
 * @param checkVoid
 */
export function convertObjectToFormData(obj: any, checkVoid?: boolean): FormData {
    const formData = new FormData();
    const checkedVoid = checkVoid || false;
    for (const key of Object.keys(obj)) {
        if (!checkedVoid) {
            if (obj[key] !== undefined && obj[key] !== null && obj[key] !== "" && obj[key].length !== 0) {
                if (Array.isArray(obj[key]) && Object.prototype.toString.call(obj[key][0])) {
                    obj[key].forEach((value: any) => {
                        formData.append(key, value);
                    });
                } else {
                    formData.append(key, obj[key]);
                }
            }
        } else if (obj[key] !== undefined && obj[key] !== "") {
            if (Array.isArray(obj[key]) && Object.prototype.toString.call(obj[key][0])) {
                obj[key].forEach((value: any) => {
                    formData.append(key, value);
                });
            } else {
                formData.append(key, obj[key]);
            }
        }
    }
    return formData;
}

export function getDefaultValue(value: any, defaultValue: any = "--") {
    return isNil(value) ? defaultValue : value;
}

// 获取属性值
export function getValueByProp(data: any, prop: string, defaultValue?: any) {
    const defaultText = isUndefined(defaultValue) ? DEFAULT_VALUE : defaultValue;
    const value = get(data, prop);
    return isNil(value) || value === "" ? defaultText : value;
}
